/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
import RESOURCE_NAMES from '../App/resources';
var START_LIFE_EVENTS_FORM = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, "".concat(RESOURCE_NAMES.lifeEventsForm, "/Start"));
var SET_LIFE_EVENTS_SELECTION = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.lifeEventsForm);
var FINISH_LIFE_EVENT_FORM_TYPE = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, "".concat(RESOURCE_NAMES.lifeEventsForm, "/Exit"));
var LIFE_EVENT_HISTORY = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.lifeEventsHistory);
var LIFE_EVENT_LIST_REMOTE_SYSTEMS = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.lifeEventsRemoteSystems);
var LIFE_EVENT_SEND_TO_REMOTE_SYSTEMS = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, "".concat(RESOURCE_NAMES.lifeEventsRemoteSystems, "/send"));
var LIFE_EVENT_SET_SELECTED_REMOTE_SYSTEMS = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, "".concat(RESOURCE_NAMES.lifeEventsRemoteSystems, "/select"));
var LIFE_EVENT_SHOW_REMOTE_SYSTEMS_VALIDATION_MESSAGE = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, "".concat(RESOURCE_NAMES.lifeEventsRemoteSystems, "/nothing_selected"));
export { START_LIFE_EVENTS_FORM, SET_LIFE_EVENTS_SELECTION, FINISH_LIFE_EVENT_FORM_TYPE, LIFE_EVENT_HISTORY, LIFE_EVENT_LIST_REMOTE_SYSTEMS, LIFE_EVENT_SEND_TO_REMOTE_SYSTEMS, LIFE_EVENT_SET_SELECTED_REMOTE_SYSTEMS, LIFE_EVENT_SHOW_REMOTE_SYSTEMS_VALIDATION_MESSAGE };